
import React from "react";
import { reactElement, reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { FloatingPortal, FloatingFocusManager, useFocus, useRole, useDismiss, useHover, useInteractions, autoUpdate, autoPlacement, offset, useFloating } from "@floating-ui/react";
import { createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { singleton as singleton_1, ofArray, append as append_1 } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import Question_Circle from "../../public/assets/icons/Question_Circle.svg";
import { reactApi as reactApi_1 } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";

export function InformationTooltip(props) {
    let elems_2;
    const patternInput = reactApi.useState(false);
    const isOpen = patternInput[0];
    const floatingProps = useFloating({
        middleware: [offset(8), autoPlacement({
            allowedPlacements: ["top", "bottom", "right", "left"],
        })],
        onOpenChange: patternInput[1],
        open: isOpen,
        whileElementsMounted: autoUpdate,
    });
    const interactions = useInteractions([useHover(floatingProps.context, {
        move: false,
    }), useDismiss(floatingProps.context), useRole(floatingProps.context, {
        role: "tooltip",
    }), useFocus(floatingProps.context)]);
    return reactElement("div", createObj(ofArray([["className", join(" ", ["inline-flex", "items-center"])], (elems_2 = toList(delay(() => {
        let elems;
        return append(singleton(reactElement("div", createObj(append_1(ofArray([["ref", floatingProps.refs.setReference], ["data-test-id", props.TestId], ["className", join(" ", ["h-4", "w-4", "text-black", "cursor-help"])], (elems = [Question_Circle()], ["children", reactApi.Children.toArray(Array.from(elems))])]), interactions.getReferenceProps())))), delay(() => {
            let props_2, children_1, props_1, children;
            return isOpen ? singleton((props_2 = ofArray([["root", document.body], (children_1 = singleton_1((props_1 = ofArray([["context", floatingProps.context], ["modal", false], (children = singleton_1(reactElement("div", {
                className: join(" ", ["z-50", "bg-white", "shadow-xl", "shadow-slate-400", "p-3.5", "max-w-xs", "text-sm", "text-black", "leading-5", "outline-none"]),
                ref: floatingProps.refs.setFloating,
                style: floatingProps.floatingStyles,
                children: reactApi.Children.toArray([props.Content]),
            })), ["children", reactApi_1.Children.toArray(children)])]), reactApi_1.createElement(FloatingFocusManager, createObj(props_1)))), ["children", reactApi_1.Children.toArray(children_1)])]), reactApi_1.createElement(FloatingPortal, createObj(props_2)))) : empty();
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

